export default __webpack_public_path__ + "static/media/10NavanaPharma.afbf5ccf.jpg";